// extracted by mini-css-extract-plugin
module.exports = {"container":"create-answer_container__3jV94","selectType":"create-answer_selectType__1riSS","selectText":"create-answer_selectText__17K8f"};